// extracted by mini-css-extract-plugin
export default {"overlay":"Loader_overlay__vojGq","box":"Loader_box__wORI1","spin":"Loader_spin__E4RJ0","sp":"Loader_sp__-Vn4d"};